module.exports = __webpack_public_path__ + "fbafc1d84a849b10c99e300c35dd0840.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_l_20.mp3
// module id = 451
// module chunks = 0